import React, { Component } from "react";
import { connect } from "react-redux";
import ComponentHeader from "../common/ComponentHeader";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Modal, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { getAllAdAccountApprovalDataApi } from "./Api";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, formatDate, isModuleExist } from "../../utils/Constant";
import { InformationModal, Spinner, VerifiedModal } from "../common";
import { toast } from "react-toastify";
import { OBJECTIVE_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { deleteAuthCommonApi, putAuthCommonApi } from "../content/Api";
import editPencil from "../../assets/images/edit-icon.png";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
import closeIcon from '../../assets/images/greay-cancel-icon.svg';
import { Form, BaseReactComponent, FormElement, FormSubmitButton, FormValidator, SelectControl } from "../../utils/form";
import { get } from "lodash";



class AdAccountApproval extends BaseReactComponent {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AutoShareAdAccountApproval);


    this.state = {
      access: AccesData,
      search: "",
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,


      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''

    };
  }


  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllAdAccountApprovalDataApi(this);

  }

  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllAdAccountApprovalDataApi(this);

      });
    }
  }

  // getDetailsUser = (data) => {
  //     this.props.history({ pathname: `/platform/details/${data?.uuid}`, state: { "id": data?.uuid } });
  // }

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };

  deleteHandle = async (id) => {
    const res = await deleteAuthCommonApi(`/adAccountApproval/${id}`);
    // console.log(res)
    if (res.status === 200) {
      this.props.getAllAdAccountApprovalDataApi(this);
      this.setState({
        delete: !this.state.delete
      });

    } else {
      toast.error("Somthis wrong...")
    }
  }
  onValidSubmit = async () => {
    this.setState({ resLoading: true })
    const info = {
      "data": {
        "status": this.state.editData.status,
      }
    }
    const res = await putAuthCommonApi(`/adAccountApproval/${this.state.editData.uuid}`, info)
    this.setState({ resLoading: false, show: false })
    this.props.getAllAdAccountApprovalDataApi(this);
  };

  render() {
    const { access } = this.state;

    const { occassionData, totalPages, currentPage } = this.props.autoShareState;
    // console.log(eventData)
    return (
      <>

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.adAccountApproval}?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        {
          this.state.show && (
            <Modal show={this.state.show} onHide={() => this.setState({ show: false })} dialogClassName={`custom-modal verify-modal vh-100  `}>
              {

                <Modal.Header className="p-0 border-0">
                  {/* <Modal.Title className='red-hat-display-bold f-s-20'>  Do you wish to {!data?.isVerified ?'verify':'un verify'} content ?</Modal.Title> */}
                  <Image src={closeIcon} className='close-icon model-icon-close' alt='icon' onClick={() => this.setState({ show: false })} />
                </Modal.Header>
              }
              <Modal.Body className="p-0">
                <h3 className='red-hat-display-bold f-s-20 p-0'>Change Ad Account Status</h3>
                <div className="pt-5">

                  <Form onValidSubmit={this.onValidSubmit}>
                    <Row>
                      <Col md={6} className="f-s-12">
                      {this.state.editData?.user?.firstName} {this.state.editData?.user?.lastName}
                      </Col>
                      <Col md={6} className="f-s-12">
                      {this.state.editData?.adAccountName} - ({ this.state.editData?.adAccountId})
                      </Col>
                      <Col>
                        <FormElement
                          valueLink={this.linkState(this, "editData.status")}
                          label="Status"
                          required
                          validations={[
                            {
                              validate: FormValidator.isRequired,
                              message: "Status cannot be empty",
                            },
                            {
                              validate: (value) => {
                                return get(this.state, 'editData.status', '') !== 'Requested';
                              },
                              message: "Please select Accepted or Rejected status",
                            }
                          ]}
                          control={{
                            type: SelectControl,
                            settings: {
                              options: [
                                { label: "Accepted", value: "Accepted" },
                                { label: "Rejected", value: "Rejected" },
                              ],
                              placeholder: "Select Status",
                              onChangeCallback: (onBlur) => {
                              },
                            },
                          }}
                        />
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                    <FormSubmitButton customClass={"primary-btn"}>
                      {this.state.resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Changing...</span> : "Change"}
                    </FormSubmitButton>
                          </div>
                  </Form>
                </div>

              </Modal.Body>
            </Modal>
          )
        }
        <section>
          <ComponentHeader
            title="Ad Account Approval"
            // isSearch={true}
            breadcrumb={[["Auto Share", "/auto-share"], ["Ad Account Approval", ""]]}
            placeholder="Search Ad Account Approval Name"
            // isBackArrow={true}
            // isReturn="/contentCollections"
            handlePrimaryBtn={() => {
              this.setState({ showEdit: true, editData: null })
            }}
          />
          <Row>
            <Col sm={2}>
              <FilterVefiedDropDown ctx={this} />
            </Col>
          </Row>
          <div className="commom-table-wrapper">
            <CustomTable
              ctx={this}
              data={occassionData?.list}
              columns={[
                {
                  width: 200,
                  title: "User Name",
                  dataIndex: "userName",
                  className: "user-name",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData.user?.firstName + " " + rowData.user?.lastName;
                  },
                },
                {
                  width: 200,
                  title: "Ad Account",
                  dataIndex: "adAccount",
                  className: "ad-account",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    return rowData.adAccountName + " - (" + rowData.adAccountId + ")";
                  },
                },
                // {
                //   width: 200,
                //   title: "Ad Account Id",
                //   dataIndex: "adAccountId",
                //   className: "ad-account-id",
                //   isCell: true,
                //   render: (text, rowData, dataKey) => {
                //     return rowData.adAccountId;
                //   },
                // },

                // {
                //   width: access.verificationAccess ? 120 : 0,
                //   title: "Verified",
                //   dataIndex: "isVerified",
                //   className: "name",
                //   isCell: true,
                // render:(text, rowData, dataKey) => {
                //  const color = rowData.isVerified ? 'green' : 'orange';
                //   return <div className=" d-flex align-items-center inter-medium">
                //     <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                //       <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                //     </Tag>
                //   </div>;
                //   },
                // },

                {

                  width: access.updateAccess ? 20 : 0,
                  title: "Status",
                  dataIndex: "",
                  className: "",
                  fixed: "right",
                  isCell: true,
                  render: (text, rowData, dataKey) => {
                    let color = "";
                    switch (rowData.status) {
                      case "Requested":
                        color = "orange";
                        break;
                      case "Accepted":
                        color = "green";
                        break;
                      case "Rejected":
                        color = "red";
                        break;
                      default:
                        break;
                    }
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.status}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: {...rowData} })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                  }

                }


                // {

                //   width: access.updateAccess || access.deleteAccess ? 20 : 0,
                //   title: "Action",
                //   dataIndex: "",
                //   className: "",
                //   fixed: "right",
                //   isCell: true,
                //   render:(text, rowData, dataKey) => {
                //       return (
                //         <OptionsDropdown
                //           editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                //           deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                //         />
                //       );
                //   },

                // }

              ]}

              total={occassionData?.length || 0}
              loading={this.state.isLoading}
            />
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  autoShareState: state.AutoShareState,
});
const mapDispatchToProps = {
  getAllAdAccountApprovalDataApi,
  deleteAuthCommonApi

};
AdAccountApproval.propTypes = {
  // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdAccountApproval));
